var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 149 149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.129594,
    y1: 0.120394,
    x2: 0.796388,
    y2: 0.782009,
    gradientTransform: "matrix(110.171875,0,0,110.898438,0.0859375,0.0429688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(21.960784%,49.411765%,72.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(21.176471%,41.176471%,58.039216%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0.191275,
    y1: 0.205792,
    x2: 0.907415,
    y2: 0.88429,
    gradientTransform: "matrix(110.171875,0,0,110.898438,38.554688,37.589844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,87.843137%,32.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,76.470588%,19.215686%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 73.867188 0.0429688 C 36.132812 0.0429688 38.492188 16.46875 38.492188 16.46875 L 38.53125 33.488281 L 74.542969 33.488281 L 74.542969 38.601562 L 24.230469 38.601562 C 24.230469 38.601562 0.0859375 35.851562 0.0859375 74.074219 C 0.0859375 112.296875 21.160156 110.941406 21.160156 110.941406 L 33.738281 110.941406 L 33.738281 93.207031 C 33.738281 93.207031 33.058594 72.046875 54.476562 72.046875 L 90.191406 72.046875 C 90.191406 72.046875 110.257812 72.371094 110.257812 52.578125 L 110.257812 19.847656 C 110.257812 19.847656 113.304688 0.0429688 73.867188 0.0429688 Z M 54.011719 11.488281 C 57.597656 11.488281 60.492188 14.394531 60.492188 17.992188 C 60.492188 21.585938 57.597656 24.496094 54.011719 24.496094 C 50.429688 24.496094 47.535156 21.585938 47.535156 17.992188 C 47.535156 14.394531 50.429688 11.488281 54.011719 11.488281 Z M 54.011719 11.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 74.941406 148.488281 C 112.675781 148.488281 110.320312 132.0625 110.320312 132.0625 L 110.277344 115.042969 L 74.269531 115.042969 L 74.269531 109.933594 L 124.578125 109.933594 C 124.578125 109.933594 148.726562 112.679688 148.726562 74.457031 C 148.726562 36.234375 127.648438 37.589844 127.648438 37.589844 L 115.070312 37.589844 L 115.070312 55.328125 C 115.070312 55.328125 115.75 76.484375 94.332031 76.484375 L 58.617188 76.484375 C 58.617188 76.484375 38.554688 76.160156 38.554688 95.953125 L 38.554688 128.683594 C 38.554688 128.683594 35.507812 148.488281 74.941406 148.488281 Z M 94.796875 137.042969 C 91.214844 137.042969 88.316406 134.136719 88.316406 130.542969 C 88.316406 126.945312 91.214844 124.039062 94.796875 124.039062 C 98.378906 124.039062 101.273438 126.945312 101.273438 130.542969 C 101.273438 134.136719 98.378906 137.042969 94.796875 137.042969 Z M 94.796875 137.042969 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.9a2072f74fea602aeca0dd2e119d85c9.svg";
export { ForwardRef as ReactComponent };